import axiosInstance from "./AxiosInstance"

export function getScriptList(pagination, pageid, search_by = "", search_keyword = "",sort_order = "",sort_by = "") {
  return axiosInstance.post("/script/scriptList", { pagination, pageid, search_by, search_keyword,sort_order,sort_by })
}

export function addScript(formData) {
  return axiosInstance.post("/script/addScript", formData,{}
  )
}

export function editScript(formData) {
  return axiosInstance.post("/script/editScript", formData, {
  })
}

export function deleteScript(scriptId) {
  return axiosInstance.post("/script/deleteScript", { script_id: scriptId })
}

export function getDiseaseWiseScript(diseaseIds) {
  const disease_ids = diseaseIds.join("|"); 
  return axiosInstance.post("script/diseaseWiseScript", { disease_ids });
}

export function formatScriptList(data) {
  if (!data || !Array.isArray(data)) {
    return []
  }
  return data.map((item) => ({
    script_id: item.script_id || item.id,
    script_text: item.script_text,
    script_status: item.script_status,
    script_type: item.script_type,  
    disease_ids: item.disease_ids || "", 
    diseases: item.diseases || [],
    created_by: item.created_by,
    created_at: item.created_at,
    updated_at: item.updated_at,
  }))
}